
import { defineComponent, ref, reactive } from 'vue';
import { queryGroupList } from '@/api/sys';

const columns = [
  {
    title: '全部',
    dataIndex: 'name',
    key: 'name',
  },
];

interface DataItem {
  key: number;
  name: string;
  person_id: number;
  children?: DataItem[];
}

// const rowSelection = {
//   onChange: (selectedRowKeys: (string | number)[], selectedRows: DataItem[]) => {
//     console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
//   },
//   onSelect: (record: DataItem, selected: boolean, selectedRows: DataItem[]) => {
//     console.log('record',record, 'selected', selected, 'selectedRows', selectedRows);
//   },
//   onSelectAll: (selected: boolean, selectedRows: DataItem[], changeRows: DataItem[]) => {
//     console.log('selected', selected, 'selectedRows', selectedRows, 'changeRows', changeRows);
//   },
// };
export default defineComponent({
  name: 'PersonModal',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    org_id: {
      type: Number,
      required: true,
    },
    role_id: {
      type: Number,
      required: true,
    },
    person_list: {
      type: Array,
      required: true,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const loading = ref(false);
    const state = reactive<{
      selectedRowKeys: Array<any>; // 选中行数组
      selected: Array<any>;
      expandedRowKeys: string;
      loading: boolean;
    }>({
      selectedRowKeys: [],
      expandedRowKeys: '',
      selected: [],
      loading: true,
    });
    // 人员数据接口请求
    const person__list: any = reactive([]); // table数据(正规格式)
    queryGroupList({ org_id: props.org_id }).then(res => {
      state.loading = false;
      state.selectedRowKeys.length = 0;
      state.selected.length = 0;
      res.data.forEach((org: any) => {
        person__list.push(org);
      });
      let list: any[] = [];
      let expandedRowKeys: any[] = [];
      if (props.person_list && props.person_list.length > 0) {
        props.person_list.forEach((item: any) => {
          person__list.forEach((item1: any) => {
            if (item.id == item1.person_id) {
              if (list.indexOf(item.id) === -1) {
                list.push(item.id);
                state.selected.push(item1);
              }
              state.selectedRowKeys.push(item1.key);
            }
            if (item1.children && item1.children.length > 0) {
              item1.children.forEach((item2: any) => {
                if (item.id == item2.person_id) {
                  if (list.indexOf(item.id) === -1) {
                    list.push(item.id);
                    state.selected.push(item2);
                  }
                  state.selectedRowKeys.push(item2.key);
                  if (expandedRowKeys.indexOf(item1.key) === -1) {
                    expandedRowKeys.push(item1.key);
                  }
                }
              });
            }
          });
        });
      }
      state.expandedRowKeys = expandedRowKeys.join(',');
    });
    const onChange = (selectedRowKeys: []) => {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      state.selectedRowKeys = selectedRowKeys;
    };
    const onSelectAll = (selected: boolean, selectedRows: DataItem[], changeRows: DataItem[]) => {
      console.log('selected', selected, 'selectedRows', selectedRows, 'changeRows', changeRows);
      let list: any[] = [];
      state.selected.length = 0;
      state.selectedRowKeys.length = 0;
      if (selected) {
        selectedRows.forEach((obj: any) => {
          if (obj.person_id != 0 && list.indexOf(obj.person_id) === -1) {
            list.push(obj.person_id);
            state.selected.push(obj);
          }
          state.selectedRowKeys.push(obj.key);
          if (obj.children && obj.children.length > 0) {
            obj.children.forEach((item2: any) => {
              if (list.indexOf(item2.person_id) === -1) {
                list.push(item2.person_id);
                state.selected.push(item2);
              }
              state.selectedRowKeys.push(item2.key);
            });
          }
        });
      }
    };
    const onSelect = (record: DataItem, selected: boolean, selectedRows: DataItem[]) => {
      console.log('record', record, 'selected', selected, 'selectedRows', selectedRows);
      state.selectedRowKeys.length = 0;
      state.selected.length = 0;
      let list: any[] = [];
      selectedRows.forEach((item: any) => {
        state.selectedRowKeys.push(item.key);
        if (list.indexOf(item.person_id) === -1) {
          list.push(item.person_id);
          state.selected.push(item);
        }
      });
      if (record.person_id == 0 && record.children && record.children.length > 0 && selected) {
        record.children.forEach((obj: any) => {
          if (state.selectedRowKeys.indexOf(obj.key) === -1) {
            state.selectedRowKeys.push(obj.key);
            state.selected.push(obj);
          }
          person__list.forEach((item1: any) => {
            if (obj.person_id == item1.person_id) {
              if (state.selectedRowKeys.indexOf(item1.key) === -1) {
                state.selectedRowKeys.push(item1.key);
              }
            }
            if (item1.children && item1.children.length > 0) {
              item1.children.forEach((item2: any) => {
                if (obj.person_id == item2.person_id) {
                  if (state.selectedRowKeys.indexOf(item2.key) === -1) {
                    state.selectedRowKeys.push(item2.key);
                  }
                }
              });
            }
          });
        });
      } else if (
        record.person_id == 0 &&
        record.children &&
        record.children.length > 0 &&
        !selected
      ) {
        record.children.forEach((obj: any) => {
          person__list.forEach((item1: any) => {
            if (obj.person_id == item1.person_id) {
              state.selectedRowKeys = state.selectedRowKeys.filter((item: any) => {
                return item1.key != item;
              });
              state.selected = state.selected.filter((item2: any) => {
                return item1.key != item2.key;
              });
            }
            if (item1.children && item1.children.length > 0) {
              item1.children.forEach((item2: any) => {
                if (obj.person_id == item2.person_id) {
                  state.selectedRowKeys = state.selectedRowKeys.filter((item: any) => {
                    return item2.key != item;
                  });
                  state.selected = state.selected.filter((item: any) => {
                    return item2.key != item.key;
                  });
                }
              });
            }
          });
        });
      } else if (record.person_id != 0 && !selected) {
        person__list.forEach((item1: any) => {
          if (record.person_id == item1.person_id) {
            state.selectedRowKeys = state.selectedRowKeys.filter((item: any) => {
              return item1.key != item;
            });
            state.selected = state.selected.filter((item2: any) => {
              return item1.key != item2.key;
            });
          }
          if (item1.children && item1.children.length > 0) {
            item1.children.forEach((item2: any) => {
              if (record.person_id == item2.person_id) {
                state.selectedRowKeys = state.selectedRowKeys.filter((item: any) => {
                  return item2.key != item;
                });
                state.selected = state.selected.filter((item: any) => {
                  return item2.key != item.key;
                });
              }
            });
          }
        });
      } else if (record.person_id != 0 && selected) {
        person__list.forEach((item1: any) => {
          if (record.person_id == item1.person_id) {
            state.selectedRowKeys.push(item1.key);
          }
          if (item1.children && item1.children.length > 0) {
            item1.children.forEach((item2: any) => {
              if (record.person_id == item2.person_id) {
                state.selectedRowKeys.push(item2.key);
              }
            });
          }
        });
      }
      let list1 = state.selected;
      list1.forEach((item: any, index: number) => {
        if (item.person_id == 0) {
          state.selected.splice(index, 1);
        }
      });
    };
    const closeTag = (key: number) => {
      let person_id: number;
      state.selected.forEach((item: any) => {
        if (item.key == key) {
          person_id = item.person_id;
        }
      });
      person__list.forEach((item1: any) => {
        if (person_id == item1.person_id) {
          state.selectedRowKeys = state.selectedRowKeys.filter((item: any) => {
            return item1.key != item;
          });
        }
        if (item1.children && item1.children.length > 0) {
          item1.children.forEach((item2: any) => {
            if (person_id == item2.person_id) {
              state.selectedRowKeys = state.selectedRowKeys.filter((item: any) => {
                return item2.key != item;
              });
            }
          });
        }
      });
      state.selected = state.selected.filter((item: any) => {
        return key != item.key;
      });
    };
    const handleSubmit = (e: Event) => {
      e.preventDefault();
      loading.value = true;
      let list: any[] = [];
      state.selected.forEach((item: any) => {
        list.push(item.person_id);
      });
      emit('ok', { person_ids: list, role_id: props.role_id, aim_org_id: props.org_id });
      loading.value = false;
    };

    return {
      props,
      state,
      loading,
      person__list,
      handleSubmit,
      onChange,
      onSelectAll,
      onSelect,
      closeTag,
      columns,
    };
  },
});
